/**
 * @fileoverview POST handler for the "/engagement/landing_page_templates/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageTemplatesDuplicateCacheKeys } from "./constants";
import type {
  PostEngagementLandingPageTemplatesDuplicateProps,
  EngagementLandingPageTemplatesDuplicateResult,
} from "./types";

export const postEngagementLandingPageTemplatesDuplicate = reactQueryMutationAdapter(
  engagementLandingPageTemplatesDuplicateCacheKeys,
  ({
    ids,
  }: PostEngagementLandingPageTemplatesDuplicateProps): Promise<EngagementLandingPageTemplatesDuplicateResult> => {
    return fetch(
      "/engagement/landing_page_templates/duplicate",
      "POST",
      {
        ids: ids,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
